import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderPoStyles {
    wrapper?: GridItemProps;
    titleText?: TypographyPresentationProps;
    orderPo?: TypographyPresentationProps;   
}

export const orderPoStyles: OrderPoStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = orderPoStyles;

const OrderPo = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.customerPO) {
        return null;
    }
    return (
 <GridItem {...styles.wrapper}>   
    <Typography {...styles.orderPo} aria-labelledby="orderPo">
        <strong>{translate("Primary PO Number")}</strong>: {order.customerPO}
    </Typography>            
 </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: OrderPo,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
